var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.socialData.children),function(social,index){return _c('v-col',{key:index,staticClass:"flex-grow-0",style:(_vm.colStyle)},[_c('masked-icon-link',{attrs:{"mask-icon":social.fields.icon,"title":social.fields.title,"href":social.fields.link,"height":_vm.height,"inverted":_vm.inverted}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }